// extracted by mini-css-extract-plugin
module.exports = {"root":"leftbar_root__2OS21","item":"leftbar_item__1rwwe","selectedItem":"leftbar_selectedItem__3MO36","icon":"leftbar_icon__3_Gir","label":"leftbar_label__1vqlu"};